import { defineStore } from 'pinia';

export const useEnvProps = defineStore('envProps', {
  state: () => ({
    envProps: null,
  }),
});
